/* global locales */
import angular from 'angular';
import 'ui-select';
import 'ng-flow';
import './postsServices';
import locales from '../../locale';

const controllers = angular.module('applicationModule.postsControllers', [
    'applicationModule.postsServices',
    'flow',
    'ui.select'
]);

controllers.controller('PostsController', ['$scope', '$rootScope', '$stateParams', 'NgTableParams', 'growl', 'Posts', 'AppsoupAPI', 'Permissions', function ($scope, $rootScope, $stateParams, NgTableParams, growl, Posts, AppsoupAPI, Permissions) {
    'use strict';
    $rootScope.$broadcast('newApp', {select: $stateParams.application_id});
    $scope.writeAccess = Permissions.hasWriteAccess('posts');
    $scope.application_id = $stateParams.application_id;
    $scope.categories = [];
    $scope.search = {};
    $scope.check = false;

    $scope.tableParams = new NgTableParams(AppsoupAPI.getTitleTableParams(), {
        getData: function (params) {
            $scope.isLoading = true;
            return Posts.getList($scope.application_id, params._params)
                .then(function (response) {
                    params.total(response.total);
                    params.count(response.per_page);
                    params.page(response.current_page);
                    return response.data;
                })
                .finally(function () {
                    $scope.isLoading = false;
                });
        },
        counts: AppsoupAPI.getDefaultCounts()
    });

    Posts.categories($scope.application_id, '').then(function (result) {
        let data = result.data;

        if (data.success) {
            $scope.categories = data.categories;
        } else {
            growl.error('MODULES.APPLICATIONS.MODULES.DISHES.GROWL.ERROR.' + data.error);
        }
    });

    $scope.searchPosts = function (search) {
        $scope.isFind = true;

        const find = angular.copy(search);
        angular.extend($scope.tableParams._params, find);
        $scope.isFind = false;
    };

    $scope.clearSearch = function () {
        $scope.search = {};
        if (angular.isDefined($scope.tableParams._params.title)) {
            $scope.tableParams._params.title = undefined;
        }
        if (angular.isDefined($scope.tableParams._params.categories)) {
            $scope.tableParams._params.categories = undefined;
        }
    };

    $scope.removePost = function (id, index) {
        Posts.remove(id)
            .then(function (result) {
                let data = result.data;

                if (data.success) {
                    growl.success('MODULES.APPLICATIONS.MODULES.POSTS.SUCCESS.DELETE');
                    $scope.tableParams.data.splice(index, 1);
                } else {
                    growl.error('MODULES.APPLICATIONS.MODULES.POSTS.ERROR.DELETE');
                }
            });
    };

    $scope.$watch('search', function () {
        $scope.check = false;
        angular.forEach($scope.search, function (val) {
            if (!angular.isUndefinedNullOrEmpty(val)) {
                $scope.check = true;
            }
        });
    }, true);
}]);

controllers.controller('PostController', ['$state', '$scope', '$rootScope', '$stateParams', 'growl', 'Posts', '$filter', '$modal', '$locale', function ($state, $scope, $rootScope, $stateParams, growl, Posts, $filter, $modal, $locale) {
    'use strict';
    $rootScope.$broadcast('newApp', {select: $stateParams.application_id});
    $scope.post = {};
    $scope.categories = [];
    $scope.post.app_id = $stateParams.application_id;

    $scope.editMode = false;

    $scope.checkDate = function () {
        $scope.post.wp_date = $filter('date')($scope.post.wp_date, 'yyyy-MM-dd');
    };

    $scope.lang = $filter('translate')('LANG');

    if (locales[$scope.lang]) {
        angular.copy(locales[$scope.lang], $locale);
        angular.extend($locale.DATETIME_FORMATS, locales[$scope.lang].DATETIME_FORMATS || {});
        angular.extend($locale.NUMBER_FORMATS, locales[$scope.lang].NUMBER_FORMATS || {});
    }

    $scope.tinymceOptions = angular.getTinymceOptions($modal);

    if (angular.isDefined($scope.lang) && $scope.lang !== 'en') {
        $scope.tinymceOptions['language'] = $scope.lang;
        $scope.tinymceOptions['language_url'] = '/assets/tinymce/' + $scope.lang + '.js';
    }

    const post_id = $stateParams.post_id;
    if (angular.isDefined(post_id)) {
        $scope.editMode = true;
        $rootScope.doingResolve = true;
        Posts.get(post_id, $stateParams.application_id).then(function (result) {
            let data = result.data;

            if (data.success) {
                $scope.post = data.post;
            }
        }).catch(function () {
            $state.go('appsoup.application.posts', {application_id: $stateParams.application_id}, growl.error('MODULES.APPLICATIONS.MODULES.POSTS.ERROR.NO_DATA'));
        }).finally(function () {
            $rootScope.doingResolve = false;
        });
    } else {
        const today = new Date();
        $scope.post.wp_date = $filter('date')(today.getTime(), 'yyyy-MM-dd');
    }

    $scope.autocomplete = function (text) {
        text = text.toLowerCase().trim();
        text = encodeURIComponent(text);
        Posts.categories($scope.post.app_id, text)
            .then(function (result) {
                let data = result.data;

                if (data.success) {
                    $scope.categories = data.categories;
                } else {
                    growl.error('MODULES.APPLICATIONS.MODULES.DISHES.GROWL.ERROR.' + data.error);
                }
            });
    };

    $scope.save = function () {
        $scope.$broadcast('show-errors-check-validity');
        if ($scope.postForm.$valid) {
            $scope.isLoading = true;

            if (angular.isDefined(post_id)) {
                $scope.post.id = post_id;
            }
            Posts.save($scope.post, $scope.editMode)
                .then(function (result) {
                    let data = result.data;

                    if (data.success) {
                        growl.success('MODULES.APPLICATIONS.MODULES.POSTS.SUCCESS.' + ($scope.editMode ? 'UPDATED' : 'CREATED'));
                        $state.go('appsoup.application.posts');
                    }
                })
                .finally(function () {
                    $scope.isLoading = false;
                });
        }
    };

    $scope.cancel = function () {
        $state.go('appsoup.application.posts');
    };

    $scope.inputErrors = {
        'wp_url': [{type: '$invalid', msg: 'FORM.ERRORS.REQUIRED'}],
        'image_url': [{type: '$invalid', msg: 'FORM.ERRORS.REQUIRED'}],
        'title': [{type: '$invalid', msg: 'FORM.ERRORS.REQUIRED'}],
        'location': [{type: '$invalid', msg: 'FORM.ERRORS.REQUIRED'}],
        'wp_date': [{type: '$invalid', msg: 'FORM.ERRORS.REQUIRED'}],
        'content': [{type: '$invalid', msg: 'FORM.ERRORS.REQUIRED'}]
    };
}]);

export default controllers;
